import AppRouter from "./routes/AppRouter";
import { NextUIProvider } from "@nextui-org/react";
import "./styles/global.css";

import eventListenerSlice from "./redux/eventListenerSlice";
//@ts-ignore
import { useDispatch } from "react-redux/es/hooks/useDispatch";
import { useEffect } from "react";
import { GoogleOAuthProvider } from '@react-oauth/google';
import GlobalModals from "./components/ui/System/GlobalModals";
import "./styles/extra.css"
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { v4 as uuid } from "uuid";
import systemSlice from "./redux/systemSlice";
import RenderIframe from "./pages/DashboardPages/License/RenderIframe";
import { ConfigProvider } from "antd";
function App() {
  //@ts-ignore
  const dispatch = useDispatch()


  const updateWindowWidth = () => {

    dispatch(eventListenerSlice.actions.setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    }))
  };

  useEffect(() => {

    const sessionId = sessionStorage.getItem("sessionId")
    if (!sessionId) {
      sessionStorage.setItem("sessionId", uuid())
    }
    window.addEventListener('resize', updateWindowWidth);
    updateWindowWidth()

    return () => {
      window.removeEventListener('resize', updateWindowWidth);
    };

  }, []);

  useEffect(() => {


    if (process.env.REACT_APP_SCREENSHOT_ENABLED) {
      const params = new URLSearchParams(window.location.search);
      const screenShotMode = params.get("screenShotMode")
      dispatch(systemSlice.actions.setScreenShotMode(screenShotMode))
    }

  }, []);

  if (!process.env.REACT_APP_DEV_MODE) {
    console.log = () => { }
  }
  return (
    <>
      {/* <React.StrictMode> */}
      <GoogleOAuthProvider clientId="669482267577-qcn8ljcocgbhj6sj4hk26ph2qevcvgke.apps.googleusercontent.com">
        <NextUIProvider >
          <ConfigProvider
            theme={{
              token: {
                // Seed Token
                colorPrimary: '#7059ef',
                borderRadius: 2,

                // Alias Token
                colorBgContainer: '#fff',
              },
            }}

          >

            <main className=" text-foreground bg-background box-border">
              <AppRouter />
            </main>
            <RenderIframe></RenderIframe>
            <GlobalModals></GlobalModals>
          </ConfigProvider>
        </NextUIProvider>
      </GoogleOAuthProvider>
      {/* </React.StrictMode> */}
    </>
  )
}

export default App